'use client';

import { faStar } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import Checkbox from '@mui/material/Radio';
import { useLocale } from 'hooks';
import PropTypes from 'prop-types';
import styles from './FundSelectBox.module.css';

function FundSelectBox({
  fund,
  selected,
  onSelect,
}) {
  const locale = useLocale();
  const translatedFund = {
    label: fund.label,
    description: fund.description,
  };
  switch (locale) {
    case 'zh-Hant':
      translatedFund.label = fund.labelChi || translatedFund.label;
      translatedFund.description = fund.descriptionChi || '';
      break;
    case 'zh-Hans':
      translatedFund.label = fund.labelSimplifiedChi || translatedFund.label;
      translatedFund.description = fund.descriptionSimplifiedChi || '';
      break;
  }
  const isSpecial = fund.special || false;

  return (
    <Grid
      sx={{
        p: 2,
        width: {
          xs: '100%',
          md: '320px',
        },
        height: '140px',
        borderColor: selected ? (isSpecial ? 'warning.main' : 'primary.main') : 'grey.300',
        borderWidth: '2px',
        borderStyle: 'solid',
        borderRadius: '16px',
        backgroundColor: selected ? 'white' : 'rgba(255, 255, 255, 0.75)',
        boxShadow: selected ? 3 : 'none',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
      }}
      onClick={onSelect}
    >
      <Grid container direction="row" sx={{ justifyContent: 'space-between', alignItems: 'start' }}>
        <Typography color='secondary.500' sx={{ fontWeight: 'bold' }}>
          {translatedFund.label}
          <Typography color={isSpecial ? 'warning' : 'primary'} component='span'>
            {isSpecial && (
              <FontAwesomeIcon icon={faStar} style={{ marginLeft: 8 }} />
            )}
          </Typography>
        </Typography>

        <Checkbox
          checked={selected}
          sx={{ p: 0, color: isSpecial ? 'warning.main' : 'primary.main' }}
          color={isSpecial ? 'warning' : 'primary'}
        />
      </Grid>

      <Typography variant='body2' color='secondary.500' sx={{ mt: 0.5 }} className={styles.truncate3lines}>
        {translatedFund.description}
      </Typography>
    </Grid>
  );
}

FundSelectBox.propTypes = {
  selected: PropTypes.bool,
  fund: PropTypes.shape({
    label: PropTypes.string,
    description: PropTypes.string,
    labelChi: PropTypes.string,
    descriptionChi: PropTypes.string,
    labelSimplifiedChi: PropTypes.string,
    descriptionSimplifiedChi: PropTypes.string,
    special: PropTypes.bool,
  }),
  onSelect: PropTypes.func,
};
export default FundSelectBox;
